var map = {
	"./dot-circle.png": 80456,
	"./gem.png": 38218,
	"./heartbeat.png": 49526,
	"./home.png": 73685,
	"./hotel.png": 82858,
	"./j.png": 79548,
	"./shopping-basket.png": 81133,
	"./theater-masks.png": 99969,
	"./tshirt.png": 40954,
	"./tv.png": 86478,
	"./utensils.png": 80768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;